import MuiFormHelperText from "@mui/material/FormHelperText";

const FormHelperText = MuiFormHelperText;

export default FormHelperText;
